import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import React from 'react'
import { Link } from 'react-router-dom'

type CtxtProps = {
    to: string
    children: React.ReactNode
    classes?: string
    isExternal?: boolean
    target?: string
}

function CtxtLink({
    to,
    children,
    classes = '',
    isExternal = false,
    target = '_blank',
}: CtxtProps): React.JSX.Element {
    const finalClasses = clsx(
        {
            'text-ctxt-blue hover:underline text-nowrap': isExternal,
            'text-ctxt-blue w-3 hover:underline': !isExternal,
        },
        classes,
    )

    if (isExternal) {
        return (
            <a
                href={to}
                target={target}
                rel="noopener noreferrer"
                className={finalClasses}
            >
                {children}
                <FontAwesomeIcon
                    icon={faUpRightFromSquare}
                    className={`w-3 ml-1`}
                />
            </a>
        )
    }

    // internal link
    return (
        <Link to={to} className={finalClasses}>
            {children}
        </Link>
    )
}

export default CtxtLink
